// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"648":"31d6cfe0","985":"1a8f005b"}[chunkId] + ".chunk.css";
};